<script>
import { mapGetters } from "vuex";
import { useAlert } from "dashboard/composables";
import validations, { getLabelTitleErrorMessage } from "./validations";
import { useVuelidate } from "@vuelidate/core";

import NextButton from "dashboard/components-next/button/Button.vue";

export default {
  components: {
    NextButton,
  },
  props: {
    selectedResponse: {
      type: Object,
      default: () => {},
    },
  },
  emits: ["close"],
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      title: "",
      description: "",
      showOnSidebar: true,
      color: "",
      // FORK: contextos a los que aplica la etiqueta.
      labelableTypes: ["conversation", "contact"],
    };
  },
  validations,
  computed: {
    ...mapGetters({
      uiFlags: "labels/getUIFlags",
    }),
    pageTitle() {
      return `${this.$t("LABEL_MGMT.EDIT.TITLE")} - ${
        this.selectedResponse.title
      }`;
    },
    labelTitleErrorMessage() {
      const errorMessage = getLabelTitleErrorMessage(this.v$);
      return this.$t(errorMessage);
    },
  },
  mounted() {
    this.setFormValues();
  },
  methods: {
    onClose() {
      this.$emit("close");
    },
    setFormValues() {
      this.title = this.selectedResponse.title;
      this.description = this.selectedResponse.description;
      this.showOnSidebar = this.selectedResponse.show_on_sidebar;
      this.color = this.selectedResponse.color;
      // FORK: labels legacy sin labelable_types se asumen conversation+contact.
      this.labelableTypes = this.selectedResponse.labelable_types || [
        "conversation",
        "contact",
      ];
    },
    editLabel() {
      this.$store
        .dispatch("labels/update", {
          id: this.selectedResponse.id,
          color: this.color,
          description: this.description,
          title: this.title.toLowerCase(),
          show_on_sidebar: this.showOnSidebar,
          labelable_types: this.labelableTypes,
        })
        .then(() => {
          useAlert(this.$t("LABEL_MGMT.EDIT.API.SUCCESS_MESSAGE"));
          setTimeout(() => this.onClose(), 10);
        })
        .catch(() => {
          useAlert(this.$t("LABEL_MGMT.EDIT.API.ERROR_MESSAGE"));
        });
    },
  },
};
</script>

<template>
  <div class="flex flex-col h-auto overflow-auto">
    <woot-modal-header :header-title="pageTitle" />
    <form class="flex flex-wrap mx-0" @submit.prevent="editLabel">
      <woot-input
        v-model="title"
        :class="{ error: v$.title.$error }"
        class="w-full label-name--input"
        :label="$t('LABEL_MGMT.FORM.NAME.LABEL')"
        :placeholder="$t('LABEL_MGMT.FORM.NAME.PLACEHOLDER')"
        :error="labelTitleErrorMessage"
        @input="v$.title.$touch"
        @blur="v$.title.$touch"
      />
      <woot-input
        v-model="description"
        :class="{ error: v$.description.$error }"
        class="w-full"
        :label="$t('LABEL_MGMT.FORM.DESCRIPTION.LABEL')"
        :placeholder="$t('LABEL_MGMT.FORM.DESCRIPTION.PLACEHOLDER')"
        @input="v$.description.$touch"
        @blur="v$.description.$touch"
      />

      <div class="w-full">
        <label>
          {{ $t("LABEL_MGMT.FORM.COLOR.LABEL") }}
          <woot-color-picker v-model="color" />
        </label>
      </div>
      <div class="w-full">
        <label>{{ $t("LABEL_MGMT.FORM.APPLIES_TO.LABEL") }}</label>
        <div class="flex flex-col gap-1 mt-1">
          <div class="flex items-center gap-2">
            <input
              v-model="labelableTypes"
              type="checkbox"
              value="conversation"
            />
            <label>{{ $t("LABEL_MGMT.FORM.APPLIES_TO.CONVERSATION") }}</label>
          </div>
          <div class="flex items-center gap-2">
            <input v-model="labelableTypes" type="checkbox" value="contact" />
            <label>{{ $t("LABEL_MGMT.FORM.APPLIES_TO.CONTACT") }}</label>
          </div>
          <div class="flex items-center gap-2">
            <input v-model="labelableTypes" type="checkbox" value="deal" />
            <label>{{ $t("LABEL_MGMT.FORM.APPLIES_TO.DEAL") }}</label>
          </div>
        </div>
      </div>
      <div class="flex items-center w-full gap-2">
        <input v-model="showOnSidebar" type="checkbox" :value="true" />
        <label for="conversation_creation">
          {{ $t("LABEL_MGMT.FORM.SHOW_ON_SIDEBAR.LABEL") }}
        </label>
      </div>
      <div class="flex items-center justify-end w-full gap-2 px-0 py-2">
        <NextButton
          faded
          slate
          type="reset"
          :label="$t('LABEL_MGMT.FORM.CANCEL')"
          @click.prevent="onClose"
        />
        <NextButton
          type="submit"
          :label="$t('LABEL_MGMT.FORM.EDIT')"
          :disabled="
            v$.title.$invalid || !labelableTypes.length || uiFlags.isUpdating
          "
          :is-loading="uiFlags.isUpdating"
        />
      </div>
    </form>
  </div>
</template>

<style lang="scss" scoped>
// Label API supports only lowercase letters
.label-name--input {
  ::v-deep {
    input {
      @apply lowercase;
    }
  }
}
</style>
